
import { basePath, apiVersion } from "./config";

export async function getPersonaimpuestos (token, query) {
  const url = `${basePath}/${apiVersion}/impuestos${query}`;


  const params = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  try {
    const response = await fetch(url, params);
    const result = await response.json();

    if (!response.ok) {
      const error = new Error(result.mensaje || "Error en la consulta de personas");
      error.endpoint = url;
      error.backendMessage = result.detalles || JSON.stringify(result);
      throw error;
    }

    return result;

  } catch (err) {
    if (!err.endpoint) {
      err.endpoint = url;
    }
    throw err;
  }
}



export async function  getImpuestosDetalle (token,id) {
  const url = `${basePath}/${apiVersion}/impuesto/${id}`;

  const params = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  try {
    const response = await fetch(url, params);
    const result = await response.json();

    if (!response.ok) {
      const error = new Error(result.mensaje || "Error en la consulta de personas");
      error.endpoint = url;
      error.backendMessage = result.detalles || JSON.stringify(result);
      throw error;
    }

    return result;

  } catch (err) {
    if (!err.endpoint) {
      err.endpoint = url;
    }
    throw err;
  }
}


